import { useEffect } from "react";
import { createPortal } from "react-dom";

// Renders children into document.body so that `fixed inset-0` overlays
// always cover the full viewport (including the sidebar), regardless of any
// ancestor that might create a containing block for fixed positioning.
// Also locks background scroll while the modal is open. Phase 4 (2026-02):
// on touch devices the body scroll lock now also freezes the position so
// iOS Safari doesn't quietly scroll the underlying page while the modal
// receives touch events.
export default function Portal({ children }) {
  useEffect(() => {
    const prevOverflow = document.body.style.overflow;
    const prevTouchAction = document.body.style.touchAction;
    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "none";
    return () => {
      document.body.style.overflow = prevOverflow;
      document.body.style.touchAction = prevTouchAction;
    };
  }, []);
  return createPortal(children, document.body);
}
